module.exports = __webpack_public_path__ + "img/freckeals.76ebb366.svg";